import React from 'react';
import { Button, Stack, CircularProgress } from '@mui/material';
import type { ClientSafeProvider, LiteralUnion } from 'next-auth/react';
import { Microsoft as MicrosoftIcon, VpnKey as VpnKeyIcon } from '@mui/icons-material';

interface ProviderButtonsProps {
  providers: Record<LiteralUnion<string, string>, ClientSafeProvider>;
  loading: string | null;
  onSignIn: (providerId: string) => void;
}

const getProviderIcon = (providerId: string) => {
  switch (providerId) {
    case 'azure-ad':
      return <MicrosoftIcon />;
    case 'credentials':
      return <VpnKeyIcon />;
    default:
      return null;
  }
};

const getProviderName = (provider: ClientSafeProvider) => {
  switch (provider.id) {
    case 'azure-ad':
      return 'Microsoft';
    case 'credentials':
      return 'Email & Password';
    default:
      return provider.name;
  }
};

export function ProviderButtons({ providers, loading, onSignIn }: ProviderButtonsProps) {
  return (
    <Stack spacing={2}>
      {Object.values(providers).map((provider) => (
        <Button
          key={provider.id}
          fullWidth
          variant="outlined"
          size="large"
          onClick={() => onSignIn(provider.id)}
          disabled={loading !== null}
          startIcon={loading === provider.id ? <CircularProgress size={20} /> : getProviderIcon(provider.id)}
          sx={{
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 500,
          }}
        >
          {loading === provider.id ? 'Signing in...' : `Sign in with ${getProviderName(provider)}`}
        </Button>
      ))}
    </Stack>
  );
}
